<template>
  <div style="margin-top: -3rem;">
    <md-dialog-content>
      <div class="ml-30 pt-30">
        <md-dialog-title style="margin-left: -3rem; font-size: 2rem;">{{options.Lang.SendAlert}}</md-dialog-title>
      </div>
      <br>
      
  <div style="margin-top: 3rem;" v-if="renderComp">
      <div id="emailvorlage">
        <br><br>
        <label style="margin-left: 0.7rem;">{{options.Lang.NachrichtVom}}: {{ datum }}</label>
        <div id="divEmail" class="md-layout-item hello">
              <!--deutsch-->
              <div style="display: flex; width: 100%;">
                <div id="editorContainer" class="blubbiblubbiblubbi haii w-100 template_editor">
                <div class="right">
                  <span @click="editor6.chain().focus().toggleBulletList().run()">
                    <md-icon>format_list_bulleted</md-icon>
                  </span>
                    <span @click="editor6.chain().focus().toggleBold().run()">
                    <md-icon>format_bold</md-icon>
                  </span>
                    <span @click="editor6.chain().focus().toggleUnderline().run()">
                    <md-icon>format_underlined</md-icon>
                  </span>
                    <span @click="editor6.chain().focus().undo().run()">
                    <md-icon>undo</md-icon>
                  </span>
                </div>
                <br>
                <editor-content class="emailBox" :editor="editor6" v-model="alertMessage"/>
              </div>
              
              </div>
              <br>
              <!--buttons-->
              <div style="display: flex; width: 100%; justify-content: space-between;">
                <div style="display: flex; align-items: center; margin-left: -2rem;">
                  <md-switch style="margin-left: 3rem;" v-model="booleanAlert">{{options.Lang.alertOnOff}}</md-switch>
                  <md-switch style="margin-left: 3rem;" v-model="booleanTest">{{options.Lang.TestAdmin}}</md-switch>
                </div>
                <md-button tabindex="7" class="md-raised md-primary" @click="setAlertMessage()">{{options.Lang.Speichern}}
                </md-button>
              </div>
          </div>
      </div>
    </div>
  
     <!--////////////////////////////////////////-->

      <Success class="errorDialog" v-if="options.showSuccess && options.user.loggedIn" :options="options"></Success>
     
    </md-dialog-content>
    
  </div>
</template>
  
<script>

import * as moment from 'moment'
import { validationMixin } from 'vuelidate'
import Success from '../../components/dialogs/Success.vue'
import {Editor, EditorContent} from '@tiptap/vue-2'
import Underline from '@tiptap/extension-underline'
import StarterKit from '@tiptap/starter-kit'

export default {
  name: 'formGlobalInfo',
  mixins: [validationMixin],
  components: {
    Success, EditorContent
  },
  props: {
    options: {
      type: Object,
      required: true,
      
    },
  },
  data: () => ({
    datum: null,
    alertMessage: null,
    renderComp: false,
    booleanAlert: false,
    booleanTest: false,
    editor6: new Editor({
      content: '',
      extensions: [
        StarterKit,
        Underline,
        
      ],
    }),
   
  
  }),
  created() {
    
  },
  async mounted() {
    await this.getAlertMessage();

   
  },
  watch: {
    clear() {
      // Check your usage of this.MdField here
    }
  },
  methods: {
    async getAlertMessage(){
      this.renderComp = false;
      let self = this;
      await this.doPost({}, 'getAlertMessage', function (res) {
        if (res.data.status === 'error') {
          self.help.log(self.$t(res.msg), false, true);
        } else {
          if(res?.data?.data[0]){
            let result = res.data.data[0]
            // console.log(result)
            self.alertMessage = result
            self.booleanAlert = result.status == "false" ? false : true
            self.booleanTest = result.test == "false" ? false : true
            self.editor6.commands.setContent(self.alertMessage.nachricht);
            self.datum = result.datum
            self.renderComp = true;
          }else{
            self.booleanAlert = false
            self.booleanTest = false
            self.datum = "noch kein datum"
            self.alertMessage = []
            self.alertMessage.nachricht = "nachricht"
          }
         
        }
      });
    },
    async setAlertMessage(){
      this.renderComp = false;
      let self = this;
      let myData = {
        status: self.booleanAlert,
        test: self.booleanTest,
        message: self.editor6.getHTML(),
        id: self.alertMessage.id
      }
      await this.doPost({data: myData}, 'setAlertMessage', function (res) {
        if (res.data.status === 'error') {
          self.help.log(self.$t(res.msg), false, true);
        } else {
          self.options.showSuccess = true;
        }
      });
      await self.setSeeStatusAll();
      await self.getAlertMessage();
    },
    async setSeeStatusAll(){
      let self = this;
      let myData = {
        status: self.booleanAlert,
        test: self.booleanTest,
      }
      await this.doPost({data: myData}, 'setSeeStatusAll', function (res) {
        if (res.data.status === 'error') {
          self.help.log(self.$t(res.msg), false, true);
        } else {
          self.options.showSuccess = true;
        }
      });
    },
    abort() {
      location.reload();
    },
    close(){
      this.options.showGlobalInfoForm = false;
    },
    openDialog() {
    },
    closeDialog() {
      this.options.showGlobalInfoForm = false;
    },
    refreshDialog() {
      let self = this;
      self.options.showGlobalInfoForm = false;
     
    }
  }
}
</script>
<style>
.formi{
  margin-right: 3rem;
}
/* .ProseMirror {        
  min-height: 13rem;
  min-width: 16.5rem;
  max-width: 16.5rem;
  overflow-x: scroll;
  overflow-y: hidden;
  max-height:  13rem;
} */

::-webkit-scrollbar {
    display: none;
}

#emailvorlage{
  margin-left: 3rem;
  margin-right: 3rem;
  margin-top: 2rem;
}
.editCat{
  z-index: 111111;
  position: absolute;
  height: 100%;
  width: 100%;
  background-color: transparent;
}
.bgEdit{
  background-color: rgb(94, 94, 94);
  padding-top: 1rem;
  padding-bottom: 1rem;
  height: 100%;
  width: 100%;
  opacity: 0.5;
}

#divEmail{
  background: white;
  width: 107%;
  padding: 3rem;
  margin-left: -3rem;
  padding-bottom: 5rem;
}

.areaa{
  padding: 10px 10px !important;
background-color: #F5F6FA !important;
line-height: 20px;
height: 52px;
font-size: 14px !important;
color: #202224 !important;
border: 0.6px solid #D5D5D5;
-webkit-text-fill-color: #A6A6A6 !important;
border-radius: 4px;
box-shadow: none !important;
-webkit-box-shadow: none !important;
max-width: 100% !important;
min-width: 100% !important;
font-family: inherit;
}

.contentEdit{
  margin-top: -14rem;
  padding: 3rem;
  background-color: white;
  width: 90%;
  height: 80%;
  left: 5%;
}
.formTD {
  background-color: rgb(249, 249, 249);
  margin-bottom: 5px;
}

.choose-file::file-selector-button {
  font-weight: bold;
  color: #202224;
  font-family: "Nunito", sans-serif !important;
  font-size: 14px !important;
  background-color: #E1E8F3;
  padding: 10px 24px;
  outline: none;
  border: none;
  border-radius: 10px;
  width: 155px;
  height: 38px;
  display: inline-block;
  margin-top: 8px;
}

.choose-file::file-selector-button:hover{
 cursor:pointer;
 background-color: #c9cbce;
}

#sigfield{
  z-index: 111111;
}

#logo{
  width: 100% !important;
}

#logoback{
  width: 100% !important;
}

.secondary,
.button-save {
  height: 38px !important;
}

.imglogoback{
  max-width: 100% !important;
  max-height: 100% !important;
}

.uploadedLogo{
  display: flex;
  justify-content: center;
  align-items: center;
  background: #E1E8F3;
  height: 260px;
  width: 284px;
  margin-top: 10px;
  margin-bottom: 10px;
}


.blubbiblubbiblubbi.haii .ProseMirror{
  min-height: 15rem !important;
  max-height: 15rem !important;
  min-width: 100% !important;
  max-width: 100% !important;
}

#street,#plz,#company,#tel,#fax,#city,#email,#impressum,#datenschutz,#color,#signature, #hello, #reply, #replyzugang, #agbs, #footerinfo, #defaultcount{
  -webkit-text-fill-color: black !important;
}

</style>